import { render, staticRenderFns } from "./TheMedicoCabecera.vue?vue&type=template&id=0ba1ac21&scoped=true&"
import script from "./TheMedicoCabecera.vue?vue&type=script&lang=js&"
export * from "./TheMedicoCabecera.vue?vue&type=script&lang=js&"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba1ac21",
  null
  
)

export default component.exports